<template>
  <div id="app">
    <router-view></router-view>
    <YorkbbsLoginDialog :type.sync="loginType" :visible.sync="loginVisible" />
  </div>
</template>

<script>
import YorkbbsLoginDialog from '@/common/account/login/dialog-login.vue';
export default {
  name: 'App',
  components:{YorkbbsLoginDialog},
  computed: {
    loginType: {
      get() {
        return this.$store.getters.loginDialogStatus.type;
      },
      set(type) {
        this.$store.commit('setLoginType', type);
      },
    },
    loginVisible: {
      get() {
        return this.$store.getters.loginDialogStatus.visible;
      },
      set(status) {
        this.$store.commit('setLoginDialogVisible', status);
      },
    },
  },
  async created() {

      
        let token = this.$cookies.get('token');
        
        if( token ){
     
            const { code, data } = await this.$axios.post('/user/v1/info/by/token', {});
        
            if( code == 0){
                //登录成功
                this.$store.dispatch("login",{token:token,user:data.user});
          
            }else{
                //登录失败
                
                this.$cookies.remove('token');
                this.$store.dispatch('logout'); 
            }
        }
        

	},
};
</script>
<style>
@import url('//at.alicdn.com/t/font_1926201_2vlfeyfcnu7.css');

html,
body,
h1,
h2,
p,
a,
img,
dl,
dt,
dd,
ol,
ul,
li,
label {
  margin: 0;
  padding: 0;
}

body {
  font-size: 16px;
  font-weight: 400;
  font-family: Arial, Helvetica, sans-serif, '宋体';
  line-height: 1;
  color: #111;
}

ol,
ul {
  list-style: none;
}

/* 去除图片底部间隙 */
img {
  border: none;
  vertical-align: top;
  max-width: 100%;
}

img:not([src]) {
  background-color: #99a9bf;
}

a {
  text-decoration: none;
  color: inherit;
}

a:not([href]) {
  cursor: default;
}

a:not([href]):hover {
  color: currentColor;
}

button {
  outline: none;
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  background-color: transparent;
  cursor: pointer;
  user-select: none;
  color: inherit;
  font-family: inherit;
}

input:focus {
  outline: none;
}

::-webkit-input-placeholder,
:-moz-placeholder,
::-moz-placeholder :-ms-input-placeholder,
input:focus::-webkit-input-placeholder {
  color: #999;
}

.wrap {
  width: 1200px;
  margin: 0 auto;
}
[class^='yk-'],
[class*=' yk-'] {
  font-family: 'yk' !important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.warrp800{
  padding: 0 15px;
  width:100%;
  box-sizing: border-box;
}
@media screen and (min-width:768px){
  .warrp800{width:800px; margin: 0 auto;  padding: 0;}
}
.cont-row{display: flex; align-items: center;}
.flex-start{align-items: flex-start;}
.flex-cont{flex:1; overflow: hidden;}
.mrg-btm20{margin-bottom: 20px;}
.mrg-btm30{margin-bottom: 30px;}
.ovhd{overflow: hidden;}
.only-pc{
  display: none;
}
.only-mobile{
  display: none;
}
@media screen and (max-width:768px){
  .only-mobile{display: block;}
}
@media screen and (min-width:768px){
  .only-pc{display: block;}
}
</style>
